import { LOAD_ACCOUNT_SNAPSHOT, LOAD_EVENT_SNAPSHOT } from './actionTypes';

/**
 * Reducer which loads information from the event snapshot.
 * @param loadActionPayloadKey - The key locating the data in the load action
 *    payload that represents the reducers state.
 */
export const eventSnapshotReducer = (state, action, loadActionPayloadKey) => {
  return action.type === LOAD_EVENT_SNAPSHOT ? action.payload[loadActionPayloadKey] : state;
};

/**
 * Reducer which loads information from the account snapshot.
 * @param loadActionPayloadKey - The key locating the data in the load action
 *    payload that represents the reducers state.
 */
export const accountSnapshotReducer = (state, action, loadActionPayloadKey) => {
  return action.type === LOAD_ACCOUNT_SNAPSHOT ? action.payload[loadActionPayloadKey] : state;
};
